import React, { useEffect, useState } from "react";
import { Flex, IconButton, Input } from "@chakra-ui/react";
import { TalesArea } from "../../../../../../../utils/types/TalesArea";
import { useDispatch } from "react-redux";
import { AppThunkDispatch } from "../../../../../../../store";
import { editArea } from "../../../../../../../store/aree/actions/edit";
import { SmallAddIcon } from "@chakra-ui/icons";

interface Props {
  area: TalesArea;
}
export default function NewGuestInput({ area }: Props) {
  const [newGuest, setNewGuest] = useState<string>("");
  useEffect(() => {}, [newGuest]);

  const dispatch = useDispatch<AppThunkDispatch>();
  const handleSubmit = (e: React.MouseEvent<HTMLElement>) => {
    if (newGuest) {
      dispatch(editArea({ ...area, guests: [...area.guests, newGuest] }));
    }

    setNewGuest("");
  };

  return (
    <Flex my="10px">
      <Input
        id="addGuest"
        type="text"
        onChange={(val) => setNewGuest(val.target.value)}
        value={newGuest}
        mr="10px"
      />
      <IconButton
        isRound={true}
        aria-label="Aggiungi"
        variant="solid"
        isDisabled={newGuest === ""}
        icon={<SmallAddIcon />}
        colorScheme="green"
        onClick={handleSubmit}
      />
    </Flex>
  );
}
